import type { ReactNode } from 'react';
import { useSwipeContext } from '../SwipeContext';
import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';
import { Grid, Button } from '@simplywallst/ui-core';
import type { ButtonStyleType } from '@simplywallst/ui-core';

interface Props {
  children?: ReactNode;
  zIndex?: number;
  buttonStyleType?: ButtonStyleType;
}

export const Header = ({ children, buttonStyleType = 'passive' }: Props) => {
  const { onMouseDown, onTouchStart, onClose } = useSwipeContext();
  return (
    <Grid
      as="header"
      templateRows="minmax(40px, max-content)"
      templateColumns="auto 40px"
      paddingLeft="x3"
      paddingRight="x2"
      paddingTop="x2"
    >
      <Grid
        justifyContent="left"
        alignContent="center"
        onMouseDown={onMouseDown}
        onTouchStart={onTouchStart}
      >
        {children}
      </Grid>
      <Grid justifyContent="center" alignContent="start">
        <Button
          type="button"
          styleType={buttonStyleType}
          onClick={onClose}
          aria-label="Close"
          data-cy-id="action-sheet-close"
        >
          <CrossSolid />
        </Button>
      </Grid>
    </Grid>
  );
};
